<template>
  <div
    :class="['video-player', `video-player--${this.ratio.replace(':', '-')}`]"
  >
    <VideoThumbnail
      @click.native="handleThumbnailClick"
      v-show="!showVideoPlayer"
      :imageUrl="imageUrl"
      :is_miniature="false"
      class="video-player__thumbnail"
    />
    <div v-show="showVideoPlayer" class="video-player__inner-container">
      <video id="video-player"></video>
    </div>
  </div>
</template>

<script>
import VideoThumbnail from "@/components/VideoThumbnail"
import Plyr from "@/vendor/plyr"

export default {
  props: {
    media_url: String,
    imageUrl: String,
    ratio: {
      type: String,
      default: "16:9",
      validator(value) {
        return ["4:3", "16:9"].indexOf(value) !== -1
      }
    }
  },
  components: {
    VideoThumbnail
  },
  data() {
    return {
      showVideoPlayer: false,
      player: null
    }
  },
  methods: {
    handleThumbnailClick() {
      this.player.play()
      this.showVideoPlayer = !this.showVideoPlayer
    },
    initVideo() {
      // if player already loaded, destroy it
      if (this.player !== null) {
        this.player.destroy()
      }

      // Init Player
      this.player = new Plyr("#video-player", {
        ratio: this.ratio
      })

      // Set video to player
      this.player.source = {
        type: "video",
        title: "Effeclar Due",
        sources: [
          {
            src: this.media_url,
            type: "video/mp4"
          }
        ]
      }

      // When video has ended,
      this.player.on("ended", () => {
        // if fullscreen, drop it
        if (this.player.fullscreen.active) {
          this.player.fullscreen.exit()
        }

        // Init the video => destroy it and recreate
        this.initVideo()

        // Display the thumbnail
        this.showVideoPlayer = false
      })
    }
  },
  mounted() {
    this.initVideo()
  }
}
</script>

<style src="@/vendor/plyr/index.css"></style>
<style lang="scss">
@import "@/styles/variables.scss";

.video-player {
  position: relative;
  user-select: none;
  box-shadow: 0px 12px 37px -6px rgba(0, 0, 0, 0.28);
  margin-bottom: 24px;
  width: 100%;

  &--4-3 {
    /* 75% ==> 4:3 aspect ratio */
    padding-bottom: 75%;
  }

  &--16-9 {
    /* 56.25% ==> 16:9 aspect ratio */
    padding-bottom: 56.25%;
  }

  .plyr,
  .plyr__video-wrapper,
  .plyr audio,
  .plyr video {
    height: 100%;
    width: 100%;
    box-shadow: 0 0 0 0 #00000000 !important;
  }

  .plyr__tab-focus {
    background: var(--color-secondary) !important;
    box-shadow: 0 0 0 5px var(--color-secondary--light);
  }

  .plyr__control {
    &:hover,
    &--overlaid {
      background: var(--color-secondary) !important;
    }

    &:active {
      background: var(--color-secondary--light) !important;
    }
  }

  .video-player__inner-container,
  .video-thumbnail {
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    height: 100% !important;
    width: 100% !important;
  }
}
</style>
